import { Injectable } from '@angular/core';
import { CommonQueryService } from '../../main/content/apps/queryFiles';
import * as moment from 'moment';
import * as momentTimeZone from 'moment-timezone';
import { convertUTCtoEST } from '../../main/content/apps/utils';

@Injectable()
export class AuditHistoryService {

  public roleId: any;
  public userId: any;

  constructor(
    public commonQueryService: CommonQueryService,
  ) {
    this.userId = window.localStorage.getItem('userUID');
    this.roleId = window.localStorage.getItem('roleId');
  }

  auditHistoryCall(auditLogPayload) {
    auditLogPayload['createdAt'] = "now()";

    return new Promise((resolve, reject) => {
      let oldData: any = {};

      let newData: any = {};

      for (const [oldDataKey, oldDatValue] of Object.entries(auditLogPayload.oldData)) {
        for (const [newDataKey, newDatValue] of Object.entries(auditLogPayload.newData)) {

          if (oldDataKey == newDataKey && oldDatValue !== newDatValue
            && JSON.stringify(oldDatValue) !== '[]' && JSON.stringify(newDatValue) !== '[]' && JSON.stringify(oldDatValue) !== '0.00' && JSON.stringify(newDatValue) !== '0') {
            oldData[oldDataKey] = oldDatValue;
            newData[newDataKey] = newDatValue;

          }
        }
      }

      oldData = encodeURIComponent(JSON.stringify(oldData));
      newData = encodeURIComponent(JSON.stringify(newData));


      if (oldData !== "%7B%7D" && newData !== "%7B%7D") {

        auditLogPayload['oldData'] = oldData;
        auditLogPayload['newData'] = newData;


        this.commonQueryService.CREATE_AUDIT_LOG_CALL(auditLogPayload).subscribe((resonseLog) => {
        })

      } else {
        console.log("No  Changes happended");

      }
    })

  }

  fetchLogsByOrderId(orderId, event_types) {
    return new Promise((resolve, reject) => {

      this.commonQueryService.GET_AUDIT_HISTORY_BY_ORDER_ID(orderId, event_types)
        .valueChanges.subscribe((resonseLog: any) => {
          let auditLogData = resonseLog && resonseLog.data && resonseLog.data.allAuditLogs &&
            resonseLog.data.allAuditLogs.nodes.length > 0 ? resonseLog.data.allAuditLogs.nodes
            : [];
          resolve(auditLogData);
        })
    })
  }

  formatAuditLogData(auditData) {

    let tempData = [];
    return new Promise(async (resolve, reject) => {

      for (let i = 0; i < auditData.length; i++) {

        let temp = {
          auditLogsId: auditData[i].auditLogsId ? auditData[i].auditLogsId : null,
          auditType: auditData[i].auditType ? auditData[i].auditType : null,
          // createdAt: auditData[i].createdAt ? momentTimeZone(auditData[i].createdAt + "Z").tz('America/New_York') : null,
          createdAt: auditData[i].createdAt ? await convertUTCtoEST(auditData[i].createdAt) : null,
          logsDesc: auditData[i].logsDesc ? auditData[i].logsDesc : null,
          newData: auditData[i].newData ? JSON.parse(decodeURIComponent(auditData[i].newData)) : null,
          oldData: auditData[i].oldData ? JSON.parse(decodeURIComponent(auditData[i].oldData)) : null,
          orderId: auditData[i].auditType ? auditData[i].orderId : null,
          platform: auditData[i].platform ? auditData[i].platform : null,
          roleId: auditData[i].roleId ? auditData[i].roleId : null,
          status: auditData[i].status ? auditData[i].status : null,
          updatedAt: auditData[i].updatedAt ? auditData[i].updatedAt : null,
          userId: auditData[i].userId ? auditData[i].userId : null,
          userName: auditData[i].userByUserId ? auditData[i].userByUserId.firstName + " " + auditData[i].userByUserId.lastName : "",
        };

        let oldData = [], newData = [];
        if (auditData[i].oldData) {
          for (const [oldDataKey, oldDatValue] of Object.entries(JSON.parse(decodeURIComponent(auditData[i].oldData)))) {

            let temp = {};
            temp['key'] = oldDataKey;
            temp['value'] = oldDatValue;

            oldData.push(temp);

          }
        }

        if (auditData[i].newData) {

          for (const [newDataKey, newDatValue] of Object.entries(JSON.parse(decodeURIComponent(auditData[i].newData)))) {

            let temp = {};
            temp['key'] = newDataKey;
            temp['value'] = newDatValue;
            newData.push(temp);

          }
        }

        temp['newData'] = newData;
        temp['oldData'] = oldData;


        tempData.push(temp);

      }

      resolve(tempData);

    })
  }

  formatAuditLogPermData(auditData) {
    let tempData = [];
    return new Promise((resolve, reject) => {

      for (let i = 0; i < auditData.length; i++) {

        let temp = {
          auditLogsId: auditData[i].auditLogsId ? auditData[i].auditLogsId : null,
          auditType: auditData[i].auditType ? auditData[i].auditType : null,
          createdAt: auditData[i].createdAt ? auditData[i].createdAt : null,
          logsDesc: auditData[i].logsDesc ? auditData[i].logsDesc : null,
          orderId: auditData[i].auditType ? auditData[i].orderId : null,
          platform: auditData[i].platform ? auditData[i].platform : null,
          roleId: auditData[i].roleId ? auditData[i].roleId : null,
          status: auditData[i].status ? auditData[i].status : null,
          updatedAt: auditData[i].updatedAt ? auditData[i].updatedAt : null,
          userId: auditData[i].userId ? auditData[i].userId : null,
          userName: auditData[i].userName ? auditData[i].userName : "",
        };

        for (let j = 0; j < auditData[i].newData.length; j++) {
          let statusData = auditData[i] && auditData[i].newData[j] && auditData[i].newData[j].value && auditData[i].newData[j].value.statuses && auditData[i].newData[j].value.statuses.length > 0
            ? auditData[i].newData[j].value.statuses : [];
          let menuData = auditData[i] && auditData[i].newData[j] && auditData[i].newData[j].value && auditData[i].newData[j].value.menus && auditData[i].newData[j].value.menus.length > 0
            ? auditData[i].newData[j].value.menus : [];

          let statusFormat = [], menuFormat = [];
          for (let i = 0; i < statusData.length; i++) {
            let singleStatus = [];
            for (const [newDataKey, newDatValue] of Object.entries(statusData[i])) {

              let temp = {};
              temp['key'] = newDataKey;
              temp['value'] = newDatValue;
              singleStatus.push(temp);
            }
            statusFormat.push(singleStatus);

          }
          temp['statuses'] = statusFormat;

          for (let i = 0; i < menuData.length; i++) {
            let singleMenu = [];
            for (const [newDataKey, newDatValue] of Object.entries(menuData[i])) {
              let temp = {};
              temp['key'] = newDataKey;
              temp['value'] = newDatValue;
              singleMenu.push(temp);
            }
            menuFormat.push(singleMenu);

          }
          temp['menus'] = menuFormat;

        }
        tempData.push(temp);
      }
      resolve(tempData);
    })
  }

  auditHistoryForCreateOrDeleteCall(auditLogPayload) {
    auditLogPayload['createdAt'] = "now()";

    return new Promise((resolve, reject) => {

      if (auditLogPayload.newData) {
        auditLogPayload['newData'] = encodeURIComponent(JSON.stringify(auditLogPayload.newData));
      }

      this.commonQueryService.CREATE_AUDIT_LOG_CALL(auditLogPayload).subscribe((resonseLog) => {
      });

    })

  }

  auditHistoryForStatusChange(auditLogPayload) {
    auditLogPayload['createdAt'] = "now()";

    return new Promise((resolve, reject) => {

      if (auditLogPayload.newData) {
        auditLogPayload['newData'] = encodeURIComponent(JSON.stringify(auditLogPayload.newData));
      }
      if (auditLogPayload.oldData) {
        auditLogPayload['oldData'] = encodeURIComponent(JSON.stringify(auditLogPayload.oldData));
      }

      this.commonQueryService.CREATE_AUDIT_LOG_CALL(auditLogPayload).subscribe((resonseLog) => {
      });

    })

  }

  auditHistoryForExeChange(auditLogPayload) {
    auditLogPayload['createdAt'] = "now()";

    return new Promise((resolve, reject) => {

      if (auditLogPayload.newData) {
        auditLogPayload['newData'] = encodeURIComponent(JSON.stringify(auditLogPayload.newData));
      }
      if (auditLogPayload.oldData) {
        auditLogPayload['oldData'] = encodeURIComponent(JSON.stringify(auditLogPayload.oldData));
      }

      this.commonQueryService.CREATE_AUDIT_LOG_CALL(auditLogPayload).subscribe((resonseLog) => {
      });

    })

  }

  fetchLogs(event_types) {
    return new Promise((resolve, reject) => {

      this.commonQueryService.GET_AUDIT_HISTORY(event_types)
        .valueChanges.subscribe((resonseLog: any) => {

          let auditLogData = resonseLog && resonseLog.data && resonseLog.data.allAuditLogs
          resonseLog.data.allAuditLogs.nodes.length > 0 ? resonseLog.data.allAuditLogs.nodes
            : [];

          resolve(auditLogData.nodes);

        })
    })
  }


  createUpdateDeleteAuditLog(status, newData, oldData, logsDesc, auditType) {

    let auditLogPayload = {
      roleId: this.roleId,
      userId: this.userId,
      orderId: null,
      newData: newData,
      oldData: oldData,
      auditType: auditType,
      logsDesc: logsDesc,
      platform: "Executive Dashboard",
      status: status
    };

    this.auditHistoryForStatusChange(auditLogPayload);
  }

  listConfigurationLogs(event_types) {
    return new Promise((resolve, reject) => {

      this.commonQueryService.GET_AUDIT_HISTORY(event_types)
        .valueChanges.subscribe((resonseLog: any) => {

          let auditLogData = resonseLog && resonseLog.data && resonseLog.data.allAuditLogs
          resonseLog.data.allAuditLogs.nodes.length > 0 ? resonseLog.data.allAuditLogs.nodes
            : [];

          resolve(auditLogData.nodes);

        })
    })
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/core/services/audit-history.service.ts